import React from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import UserMenuResponsive from './Menu'; // ajuste o caminho
import { formatCPF_CNPJ, toTitleCase } from '../utils/formatters';

const MainAppBar = ({ empresa, userData, senhaDestaque, setOpenModal, handleLogout }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <AppBar position="fixed" color="inherit" elevation={1}>
      <Toolbar sx={{ justifyContent: 'space-between', px: { xs: 1, sm: 2 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
          <a href={empresa.logo.href} target="_blank" rel="noopener noreferrer">
            <Box
              component="img"
              src={empresa.logo.src}
              alt={empresa.logo.alt}
              sx={{
                height: isMobile ? 32 : 40,
                mr: 2,
                maxWidth: '100%',
                objectFit: 'contain',
              }}
            />
          </a>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="h6" noWrap>
              {userData.role === 'master' ? 'Usuários' : 'Boletos'}{empresa.id !== 'compsoft' ? ` - ${empresa.nome}` : ''}
            </Typography>
            <Typography variant="subtitle2" noWrap>
              {formatCPF_CNPJ(userData.usuario)} - {toTitleCase(userData.nome)}
            </Typography>
          </Box>
        </Box>

        <Box>
          <UserMenuResponsive
            senhaDestaque={senhaDestaque}
            setOpenModal={setOpenModal}
            handleLogout={handleLogout}
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default MainAppBar;